export const handleResponseError = (error, onError = () => {}) => {
  try {
    if (!error || !error.response) {
      return Promise.reject('No response');
    }
    
    const { data: { message, validationDetails } } = error.response;
    if (validationDetails && validationDetails.body && validationDetails.body.length > 0) {
      if (validationDetails.body[0].message) {
        return onError(validationDetails.body[0].message);
      }
    }

    onError(message ? message : 'משהו השתבש.');
    return Promise.reject(error);
  } catch (error) {
    onError('משהו השתבש.');
    return Promise.reject(error);
  }
};
